export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_PAYSLIPS":
      return action.payload;
    case "CREATE_PAYSLIP":
      return [...state, action.payload];
    case "DELETE_PAYSLIP":
      return state.filter(({ _id }) => _id !== action.payload.payload);
    default:
      return state;
  }
};
